<template>
<v-app id="registration-page">
      <cookie-law theme="blood-orange--rounded" 
                  buttonText="ACCETTO!">
                  <div slot="message">
                    QuickBe Utilizza cookie tecnici e di terze parti per fornirti il migliore servizio possible, 
                    puoi vedere in dettaglio cosa usiamo e come disabilitarlo da qui:
                    <router-link class="q-orange"
                      :title="getString('Uso dei cookies')"
                      to="/legal/cookie">Info Cookie
                    </router-link>
            </div>
      </cookie-law>
    <v-content style="margin-bottom:150px">
        <header-p></header-p>
        <v-container >
            <div style="text-align:center">
            <h1>{{getString(`QuickBe - Il nostro percorso`)}}</h1>
            <h3>{{getString(`Questo è il viaggio che abbiamo intrapreso tutti insieme con QuickBe, unisciti a noi!`)}}</h3>
            <h5>{{getString(`Qui verranno pubblicate tutte le nuove funzionalità`)}}</h5>
            </div>
        <v-flex x12>
            <v-flex hidden-md-and-up>
                <v-timeline dense >
                    <v-timeline-item v-for="(item,i) in items" :key="i" color="red lighten-2" large>
                        <span slot="opposite">{{item.caption}}</span>
                        <v-card class="elevation-2">
                            <v-card-title class="headline">{{item.title}}</v-card-title>
                            <v-card-text v-html="item.desc">                            
                            </v-card-text>
                        </v-card>
                    </v-timeline-item>
                </v-timeline>
            </v-flex>
            <v-flex hidden-sm-and-down>
            <v-timeline>
                <v-timeline-item v-for="(item,i) in items" :key="i" color="red lighten-2" large>
                    <span slot="opposite">{{item.caption}}</span>
                    <v-card class="elevation-2">
                        <v-card-title class="headline">{{item.title}}</v-card-title>
                        <v-card-text v-html="item.desc">                            
                        </v-card-text>
                    </v-card>
                </v-timeline-item>
            </v-timeline>
            </v-flex>
        </v-flex>
         <v-layout column>
                <v-flex xs12 sm4 class="my-3">
                    <div class="text-xs-center">
                        <v-container>
                            <v-btn class="q-orange" @click="$router.push({path:'/'})">{{getString('Torna a ')}}QuickBe</v-btn>
                        </v-container>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
    <v-footer dark height="auto" class=".footer">
        <v-card class="flex" flat tile>
            <v-card-title class="q-orange-bk">
                <strong class="subheading">{{getString("Seguici sui social!")}}</strong>
                <v-spacer></v-spacer>
                <v-btn v-for="icon in icons" :key="icon.ic" class="mx-3" dark icon @click="navigate(icon.url)">
                    <v-icon size="24px">{{ icon.ic }}</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="grey darken-3 justify-center" style="text-align:center">
                &copy;{{(new Date()).getFullYear()}} — &nbsp;<strong>Dew Studio </strong> &nbsp; — &nbsp;
                <a href="https://plaza.quickbe.app">{{getString('QuickBe Plaza')}}</a>&nbsp; — &nbsp;
                <router-link to="/legal/tec">{{getString('Trattamento dati')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/legal/cookie">{{('Cookie Policy')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/legal/eula">{{('Termini e condizioni')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/admin/login">{{getString('Portale')}}</router-link>
            </v-card-text>
        </v-card>
    </v-footer>
</v-app>
</template>

<script>
import HeaderP from './Header'
import CookieLaw from "vue-cookie-law";
export default {
    name: 'TimeLine',
    components: {
        HeaderP,
        CookieLaw
    },
    computed: {
        items: function(){
            return [
                {
                    caption: this.getString(`Dove tutto ha avuto inizio`),
                    desc: this.getString(`Partendo da Barbero, si ha avuta l'idea di migliorare la piattaforma e renderla ideale per una platea maggiore di professionisti, tutto attraverso un rebrand e ad una riprogettazione totale.`),
                    title: '20/08/2018 - '+ this.getString(`Il concepimento dell'idea`)
                },
                {
                    caption: this.getString(`Studi approfonditi`),
                    desc: this.getString(`La riprogettazione ha richiesto lo studio di nuove tecnologie, in modo da fornire miglioramenti sensibili e l'aggiunta di tante nuove funzionalità.`),
                    title: '05/09/2018 - '+ this.getString(`Miglioramenti`)
                },
                {
                    caption: this.getString(`Ridisegnato completamente il calendario`),
                    desc: this.getString(`Ora il calendario è più flessibile, più intuitivo e più leggero!`),
                    title: '28/09/2018 - '+ this.getString(`Il nuovo calendario`)
                },
                {
                    caption: this.getString(`Aggiunta funzionalità di comunicazione`),
                    desc: this.getString(`Ogni professionista ora può inviare notifiche di offerte e altre comunicazioni ai propri clienti.`),
                    title: '04/10/2018 - '+ this.getString(`La Plaza`)
                },
                {
                    caption: this.getString(`Welcome to the Plaza`),
                    desc: this.getString(`Iniziato lo sviluppo di QuickBe Plaza, la piattaforma vetrina dedicata ai professionisti che usano QuickBe.`),
                    title: '12/10/2018 - '+ this.getString(`La Plaza`)
                },
                {
                    caption: this.getString(`Test sul campo`),
                    desc: this.getString(`Grazie all'aiuto di molti nostri clienti ed ai loro FEEDBACK, abbiamo avuto la possibilità di effettuare test sul campo per la nuova piattaforma e le nuove app.`),
                    title: '16/11/2018 - '+ this.getString(`Testing`)
                },
                {
                    caption: this.getString(`Finalmente online!`),
                    desc: this.getString(`Dopo tanta fatica finalmente QuickBe, online parallelamente a Barbero, inizia il suo percorso! Da qui in poi vi aggiorneremo costantemente sulle nuove features`),
                    title: '01/12/2018 - '+ this.getString(`Il lancio`)
                },
                {
                    caption: this.getString(`Tutorial e materiale pubblicitario!`),
                    desc: this.getString(`Una pagina con materiale pubblicitario ed una con i tutorial sono state aggiunte al sistema, ora usare QuickBe sarà molto più semplice!`),
                    title: '12/12/2018 - '+ this.getString(`Aggiornamento marketing`)
                },
                {
                    caption: this.getString(`Possibilità di assegnare servizi diversi`),
                    desc: this.getString(`Ora puoi assegnare servizi diversi ad ogni dipendenti, e l'app in automatico capirà dove indirizzare l'utente in base ai servizi scelti!`),
                    title: '06/06/2018 - '+ this.getString(`Feature dipendenti`)
                }
            ]
        }
    },
    data: () => {
        return {
            icons: [{
                    ic: 'fab fa-facebook',
                    url: 'https://www.facebook.com/QuickBeApp/'
                },
                {
                    ic: 'fab fa-instagram',
                    url: 'https://www.instagram.com/quickbeapp/'
                }
            ]
        }
    },
    methods: {
        navigate: function (url) {
            window.open(url)
        },
        getString: function (key) {
            let page = this.$store.state.currentTranslator.getString(key)
            return page
        }
    }
}
</script>

<style scoped>
h2,
h3,
h4 {
    color: #d5725b;
}

.c-table td {
    padding-left: 10px;
    padding-right: 10px;
    border-bottom: solid thin #bbb;
    padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/frontend/TimeLine.vue